export default "__VITE_ASSET__D2vZHzXz__"